var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenTw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1407 2.14235C20.3697 2.51726 19.5385 2.76363 18.6774 2.88146C19.5586 2.31374 20.2395 1.41395 20.5599 0.332064C19.7288 0.867652 18.8076 1.24256 17.8362 1.4568C17.0451 0.535587 15.9336 0 14.6719 0C12.3187 0 10.3961 2.05666 10.3961 4.59534C10.3961 4.95954 10.4361 5.31303 10.5062 5.64509C6.94135 5.45228 3.76702 3.62057 1.65413 0.846228C1.28363 1.52107 1.07334 2.31374 1.07334 3.14925C1.07334 4.7453 1.82437 6.15925 2.98595 6.96264C2.27498 6.96264 1.61408 6.7484 1.03329 6.42705V6.45918C1.03329 8.68723 2.51531 10.5511 4.47799 10.9688C3.84786 11.1533 3.18632 11.179 2.54535 11.0438C2.81733 11.957 3.34999 12.756 4.06845 13.3286C4.78691 13.9011 5.65504 14.2184 6.55082 14.2359C5.03238 15.5218 3.15017 16.2169 1.21353 16.2069C0.873068 16.2069 0.532603 16.1854 0.192139 16.1426C2.09474 17.4494 4.35783 18.21 6.78113 18.21C14.6719 18.21 19.0078 11.2045 19.0078 5.13093C19.0078 4.9274 19.0078 4.73459 18.9978 4.53107C19.839 3.88836 20.5599 3.07427 21.1407 2.14235Z",
    fill: "#58B310"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTw);
export default __webpack_public_path__ + "static/media/green_tw.6a7eab18fae21f447be850dfe56cc4d5.svg";
export { ForwardRef as ReactComponent };